// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"SchemaPage_pageHeader__3rkzs","flex":"SchemaPage_flex__CBxSa","filters":"SchemaPage_filters__2QBkx","headerContainer":"SchemaPage_headerContainer__1sm0U"};